module.exports = __webpack_public_path__ + "img/turbo_on.99198999.svg";